import { render, staticRenderFns } from "./AttributesSectionEditor.vue?vue&type=template&id=30c05b2e"
import script from "./AttributesSectionEditor.vue?vue&type=script&lang=ts"
export * from "./AttributesSectionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports